import type { PayloadAction } from '@reduxjs/toolkit';
import type { OrganizationState } from './organization-interface';

export const setSelectedOrganizationFun = (
  state: OrganizationState,
  action: PayloadAction<string>,
) => {
  state.selectedOrganization = action.payload;
};
